<template>
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :header="model ? $t('newItem.Edittitle') : $t('newItem.title')"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              :required-icon="true"
              id="code"
              name="code"
              :label="$t('newItem.code')"
              :rules="{ required: true }"
              :disabled="true"
              v-model="categoryform.Code"
              type="text"
              placeholder=" "
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="true"
              id="Prefix code"
              name="Prefix code"
              :label="$t('newItem.prefixcode')"
              :rules="{ required: true, alphabet: true }"
              :disabled="DisablePrefix"
              v-model="categoryform.Prefix"
              type="text"
              placeholder=" "
              :maxlength="15"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="true"
              id="Start Value"
              name="Start Value"
              :label="$t('newItem.startvalue')"
              :rules="{ required: true, numeric: true }"
              :disabled="IsDisabled"
              v-model="categoryform.StartValue"
              type="text"
              placeholder=" "
              :maxlength="10"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="true"
              id="Type name"
              name="Type name"
              :label="$t('newItem.typename')"
              :rules="{ required: true }"
              v-model="categoryform.Name"
              type="text"
              placeholder=" "
              case="Capital"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="field d-flex align-items-center pt-2">
            <Checkbox
              v-model="categoryform.NoDuration"
              inputId="ingredient4"
              name="No Duration"
              value="true"
            />
            <label for="ingredient4" class="ms-2 mb-0 mt-1">{{
              $t("newItem.noduration")
            }}</label>
          </div>
        </b-col>
      </b-row>
      <Footer
        @cancel="(showDialog = false), IsClear()"
        :cancelhide="false"
        :label="label"
        :loading="Saveloader"
      />
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist
    :visible="alreadyexistpop"
    @ok="alreadyclosetrigger()"
    :selectedcontent="selectedcontent"
  />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import CategoryService from "../../../../../../modules/Inventory/Service/CategoryService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";
export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    TextField,
    Footer,
  },

  setup(props, { emit }) {
    const successpop = ref(false);
    const { resetForm } = useForm();

    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const { handleSubmit, errors, validate } = useForm();
    const showDialog = ref();
    const label = ref(t("btn.save"));
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");
    const DisablePrefix = ref(false);
    let Saveloader = ref(false);
    let selectedcontent = ref();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref({
      EntityId: 0,
    });
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    Entitydata.value.EntityId = props.EntityId;
    const model: any = ref(props.selectedItem);
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    function IsCreate() {
      showDialog.value = true;
      // GetProductStartValue();
      GetCode();
    }
    const alreadyexistpop = ref(false);
    const IsDisabled = ref(false);

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      if (selectedcontent.value == "Name Already Exist")
        categoryform.value.Name = "";
      else if (selectedcontent.value == "Prefix Already Exist")
        categoryform.value.Prefix = "";
    }
    //Edit Function
    async function IsEdit() {
      debugger;
      showDialog.value = true;
      emit("loadershow");
      try {
        label.value = t("btn.update");
        let Id = model.value.Id;
        const response = await CategoryService.getfindonedata(Id);
        let data = response["result"];
        Object.keys(categoryform.value).forEach((key) => {
          if (key == "NoDuration") {
            if (data.NoDuration == true) {
              categoryform.value.NoDuration = ["true"];
            } else {
              categoryform.value.NoDuration = [];
            }
          } else if (data[key]) categoryform.value[key] = data[key];
        });
        if (data.Count != 0) {
          Editmodel.value = false;
          IsDisabled.value = true;
          DisablePrefix.value = true;
        }
        // Editmodel.value = false;
        // IsDisabled.value = true;

        emit("loaderhide");
      } catch (error) {
        emit("loaderhide");

        alert(error);
      }
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        // alert('dd')
        IsSubmit();
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      // showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
      // else if (event.key == 'e') {
      // IsEdit()
      // }
      // else if (event.key == 'Escape') {

      // IsClear()
      // }
    }

    const categoryform = ref({
      Id: 0,
      Code: "",
      Name: "",
      Prefix: "",
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      StartValue: "",
      NoDuration: ref(),
    });
    async function GetCode() {
      debugger;
      try {
        let data = {
          // FormId: 19,
          EntityId: Entitydata.value.EntityId,
          HospitalId: HospitalId,
          BranchId: BranchId,
          StoreId: 0,
        };
        let result: any = await common.getCodeTemplate(data);
        console.log(result);

        categoryform.value.Code = result;
        if (result) {
          showDialog.value = true;
        }
      } catch (error) {
        alert(error);
      }
    }
    async function GetProductStartValue() {
      debugger;
      try {
        let result: any = await CategoryService.getProductStartValue();
        IsDisabled.value = result["result"]["StartValue"] != 0;
        if (result["result"]["StartValue"] != 0) {
          categoryform.value.StartValue = result["result"]["StartValue"];
        }
        console.log(result);
      } catch (error) {
        alert(error);
      }
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    //IsSubmit Function
    const IsSubmit = async () => {
      emit("loadershow");
      Saveloader.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      try {
        let response;
        categoryform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        categoryform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        categoryform.value.BranchId = 0;
        categoryform.value.HospitalId = HospitalId;
        categoryform.value.ModifiedBy = UserId;
        categoryform.value.CreatedBy = UserId;
        categoryform.value.EntityId = Number(Entitydata.value.EntityId);
        categoryform.value.NoDuration = Boolean(
          categoryform.value.NoDuration?.[0] ?? false
        );

        if (categoryform.value.Id != 0) {
          categoryform.value.EntityOperationId = props.OperationID.UpdateId;
          response = await CategoryService.updatedata(categoryform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (
            (response["result"] == "Name" || response["result"] == "Prefix") &&
            message == null
          ) {
            emit("loaderhide");
            Saveloader.value = false;
            selectedcontent.value = response["result"] + " Already Exist";
            alreadyexistpop.value = true;
          } else if (message == null) {
            emit("loaderhide");
            Saveloader.value = false;
            updatepop.value = true;
          }
        } else {
          debugger;
          categoryform.value.EntityOperationId = props.OperationID.CreateId;
          response = await CategoryService.createdata(categoryform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (
            (response["result"] == "Name" || response["result"] == "Prefix") &&
            message == null
          ) {
            emit("loaderhide");
            selectedcontent.value = response["result"] + " Already Exist";
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            emit("loaderhide");
            Saveloader.value = false;
            successpop.value = true;
          }
        }
        // loading.value = false
      } catch (error) {
        emit("loaderhide");
        alert(error);
        Saveloader.value = false;
      }
    };

    //Clear Function
    const copydataModel = JSON.parse(JSON.stringify(categoryform.value));
    const IsClear = () => {
      resetForm();
      // Object.assign(categoryform.value, copydataModel);
      emit("update:selectedItem", undefined);
      emit("close");
    };

    //popup trigger
    return {
      alreadyclosetrigger,
      alreadyexistpop,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      errors,
      showDialog,
      IsCreate,
      IsSubmit,
      IsEdit,
      categoryform,
      IsClear,
      label,
      IsDisabled,
      DisablePrefix,
      model,
      selectedcontent,
      Saveloader,
    };
  },
});
</script>
